import { useEffect } from "react";
import { Controller } from "react-hook-form";
import { LABELS } from "~/resources/Labels";
import { MESSAGES } from "~/resources/Message";
import { FormCloudEnviroment } from "~/models/Comons";
import { SIMPLInput } from "../../components/comons/input/SIMPLInput";
import { SIMPLDialog } from "../../../src/components/comons/dialog/SimplDialog";
import { SIMPLSelectDropdown } from "../../components/comons/input/SIMPLSelectDropdown";
import { SIMPLButtonCustomized } from "../../components/comons/button/SIMPLButtonCustumized";
import { UseFormCloudEnviroment } from "./UseFormCloudEnviroment";

interface Prop {
  onCloseModal: () => void;
  editedItem: FormCloudEnviroment | null;
  setConfig: Function;
  title?: string;
  refetch: () => void;
}

export const EditCloudEnviroment = ({
  onCloseModal,
  editedItem,
  setConfig,
  refetch,
  title,
}: Prop) => {
  const {
    handleSubmit,
    control,
    errors,
    updateForm,
    cloudProviderName,
    setValue,
  } = UseFormCloudEnviroment(onCloseModal, refetch, editedItem?.id!);

  useEffect(() => {
    if (editedItem?.id) {
      const data: any = editedItem;
      setValue("environmentName", editedItem.environmentName ?? "");
      setValue(
        "environmentDescription",
        editedItem.environmentDescription ?? ""
      );
      setValue("datacenterName", editedItem.datacenterName ?? "");
      setValue("datacenterDescription", editedItem.datacenterDescription ?? "");
      setValue("location", editedItem.location ?? "");
      setValue("iac", editedItem.iac ?? "");
      setValue("authenticationConfig", "");
      setValue("cloudProviderId", parseInt(data.cloudProvider?.id));
    }
  }, [editedItem, setValue, cloudProviderName]);

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    handleSubmit(updateForm)(event);
    setConfig({
      key: "",
      direction: LABELS.ASC,
    });
  };

  const renderButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label="Cancel"
          secondary
          buttonHandlerAction={onCloseModal}
        />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized label={LABELS.Update} primary />
      </div>
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={title!}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
    >
      <div className="flex justify-center">
        <div className="w-[500px]">
          <div className="flex flex-col w-full gap-y-4">
            <SIMPLInput
              name="environmentName"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Name is Required",
                },
              }}
              label="Name"
              placeholder="Name"
              required
              id="enviromentName"
              fontWeight="bold"
              errorLabel={errors.environmentName?.message}
            />

            <SIMPLInput
              name="environmentDescription"
              control={control}
              label={LABELS.Description}
              id="environmentDescription"
              fontWeight="bold"
              errorLabel={errors.environmentDescription?.message}
              placeholder={LABELS.Description}
            />

            <SIMPLInput
              name="datacenterName"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "DataCenter Name is Required",
                },
              }}
              label="DataCenter Name"
              placeholder="DataCenter Name"
              required
              id="datacenterName"
              fontWeight="bold"
              errorLabel={errors.datacenterName?.message}
            />

            <SIMPLInput
              name="datacenterDescription"
              control={control}
              label="DataCenter Description"
              placeholder="DataCenter Description"
              id="datacenterDescription"
              fontWeight="bold"
              errorLabel={errors.datacenterDescription?.message}
            />

            <SIMPLInput
              name="location"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Location is Required",
                },
              }}
              label={LABELS.Location}
              required
              id="location"
              fontWeight="bold"
              errorLabel={errors.location?.message}
              placeholder={LABELS.Location}
            />

            <SIMPLInput
              name="iac"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: "Iac is Required",
                },
              }}
              label="Iac"
              required
              id="iac"
              fontWeight="bold"
              errorLabel={errors.iac?.message}
              placeholder="Iac"
            />

            {/* Cloud Provider dropdown */}
            <div className="h-auto">
              <Controller
                name="cloudProviderId"
                control={control}
                rules={{ required: MESSAGES.MessageCloudProviderRequired }}
                render={({ field }) => (
                  <SIMPLSelectDropdown
                    id="cloudProvider"
                    label="Cloud Provider"
                    options={cloudProviderName.map((cloudProviderName) => ({
                      label: cloudProviderName.cloudProviderName,
                      value: cloudProviderName.id,
                    }))}
                    isRequired
                    value={field.value}
                    onChange={field.onChange}
                    hideErrorLabel
                    errorLabel={errors.cloudProviderId?.message as string}
                    placeholder="Cloud Provider"
                  />
                )}
              />
            </div>

            <SIMPLInput
              name="authenticationConfig"
              type="textarea"
              rows={4}
              control={control}
              label="Authentication Config"
              required
              id="authenticationConfig"
              fontWeight="bold"
              rules={{
                validate: (value: string) => {
                  if (value == null || value.trim() === "") {
                    return true;
                  }
                  try {
                    JSON.parse(value);
                    return true;
                  } catch {
                    return "Invalid JSON format";
                  }
                },
              }}
              errorLabel={errors.authenticationConfig?.message}
              placeholder="Enter valid JSON here"
            />
          </div>
        </div>
      </div>
    </SIMPLDialog>
  );
};
